<template>
    <section class="bg-light page-section" id="dev_web">
		<div class="container">
			<div class="row">
				<div class="col-lg-12 text-center">
					<h2 class="section-heading text-uppercase">Développement Web</h2>
					<h3 class="section-subheading text-muted">Suivis réguliers des nouvelles technologies.</h3>
				</div>
			</div>
			
			<div class="row">
				<div class="col-sm-4">
					<div class="team-member">
						<img class="mx-auto rounded-circle" src="img/php.png" alt="php">
						<h4>Langages Web</h4>
						<p class="text-muted">
						Pour les Développeurs Web experts en la matière.
						Il existe à l'heure actuelle de nombreux langages webs, le Développeur web est amené à connaître plusieurs de ces langages.
						</p>	
					</div>
				</div>
				
				<div class="col-sm-4">
					<div class="team-member">
						<img class="mx-auto rounded-circle" src="img/wordpress.png" alt="wordpress">
						<h4>CMS</h4>
						<p class="text-muted">
						Gestion de contenu pour tout type d'utilisateur.
						Le CMS, nécessitant une formation, peut être utilisé par un utilisateur Lambda. Des modules peuvent être développé
						par le Développeur web.
						</p>						
					</div>
				</div>				
				
				<div class="col-sm-4">
					<div class="team-member">
						<img class="mx-auto rounded-circle" src="img/symfony.png" alt="symfony">
						<h4>Frameworks</h4>
						<p class="text-muted">
						Ensemble de composants pourcréer les fondations et les grandes lignes de tout ou une partie 
						d'une application, le Framework permet de structurer le travaille du développeur web. 
						</p>					
					</div>
				</div>
				
				<div class="col-sm-4">
					<div class="team-member">
						<img class="mx-auto rounded-circle" src="img/photoshop.jpg" alt="photoshop">
						<h4>WebDesign</h4>
						<p class="text-muted">
						Création, gestion et mise à jour d'un site Internet, mettre en page un site tout en le rendant attractif.
						Il faut une parfaite connaissance des outils à utiliser mais aussi bien comprendre les objectifs du client.						
						</p>					
					</div>
				</div>
				
				<div class="col-sm-4">
					<div class="team-member">
						<img class="mx-auto rounded-circle" src="img/référencement.png" alt="référencement">
						<h4>Référencement</h4>
						<p class="text-muted">
						Un métier à part entière, création d'une visibilité pour un site web sur les moteurs de recherche. 
						Multiplication du nombre de visites du site, développement de la 
						popularité et de la notoriété, communication en ligne auprès d'une nouvelle cible d'internautes.
						</p>				
					</div>
				</div>
				
				<div class="col-sm-4">
					<div class="team-member">
						<img class="mx-auto rounded-circle" src="img/technologies.png" alt="technologies">
						<h4>Technologies</h4>
						<p class="text-muted">
						Il existe des technologies, notamment celles de Microsoft, pour rendre des applications facilement portables 
						sur Internet. Le but est de fournir un serveur web local permettant de gérer des services et évitant d'externaliser 
						des données privées sur un service web de stockage ou un hébergement web tiers.
						</p>					
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
    
}
</script>

<style lang="css">

</style>


